export default function initlegacyutils(){
    if (location.href.indexOf("datenschutz=show") !== -1) {
        setTimeout(function () {
            $("a[href='/datenschutz.html']").trigger("click");
        }, 1000);
    }

    //Automatisch zu Tab mit Hash in URL springen
    if (location.hash !== "" && $(".tab[data-tab='" + location.hash + "']").length === 1) {
        $(".tab[data-tab='" + location.hash + "']").trigger("click");
        $(window).scrollTop($(".tab[data-tab='" + location.hash + "']").offset().top - 50);

    }

    // zeigt nach Login durch Nichtkunden die Kundennummer-Erinnerung (nur bei "Kundennummer nicht zur Hand" während Registrierung)
    if (window.location.href.indexOf("preview.chefsculinar.de") !== -1) {
        var popupurl = "/preview/wspopup.htm";
    }
    else {
        var popupurl = "/wspopup.htm";
    }
    if (typeof (showwebshop) !== "undefined" && globalThis.showwebshop === true && window.location.href.indexOf("aktivierung.htm") === -1 && window.localStorage.getItem('webshop-popup') !== "noshow") {
        $.ajax({
            url: popupurl
        }).done(function (res) {
            $("body").append(res);
            $("#modalmycckunde").modal("show");
            window.localStorage.setItem('webshop-popup','noshow')
        });
        $("body").on("click", "#modalmycckunde a.right-aligned", function () {
            if ($("#noreminder").is(":checked") === true) {
                $.ajax({
                    url: popupurl,
                    method: "post",
                    data: {
                        action: "noshow"
                    }
                });
            }
        });
    }

    //QUICKFIX MOBILE NAVIGATION
    // Leere URL in XML für mobileNavigation, entfällt wenn neue Navigation live ist
    // Vermutlich durch nicht vorhandene Seiten-URLs in XML-Variante?
    $(".mainnav-mobile a[href='']").each(function () {
        var link = $(".mainnav-desk a[data-guid='" + $(this).attr("data-guid") + "']").attr("href");
        $(this).attr("href", link);
    });

    // Facebook-Login nicht mehr aktiv, wird für ggf. Reaktivierung beibehalten
    var newLoc = location.pathname + location.search;
    var successUrl = newLoc;
    var failUrl = location.pathname;
    //var successUrl = "https://www.chefsculinar.de/" + location.pathname.split("/")[location.pathname.split("/").length - 1];
    //var failUrl = "https://www.chefsculinar.de/" + location.pathname.split("/")[location.pathname.split("/").length - 1];
    $(".cc-login-container a.fb").data("successurl", successUrl);
    $(".cc-login-container a.fb").data("failurl", failUrl);
    var fbLinkHref = $(".cc-login-container a.fb").attr("href") + "&successUrl=" + $(".cc-login-container a.fb").data("successurl") + "&failUrl=" + $(".cc-login-container a.fb").data("failurl");
    //fbLinkHref = fbLinkHref.replace("xsoauth", "xsoauth/" + $.cookie("ccp-sid"));
    $(".cc-login-container a.fb").attr("href", fbLinkHref);

    //fix für Partner ohne http im Link
    $(".partner-grid a").each(function () {
        if ($(this).attr("href").indexOf("http") === -1) {
            $(this).attr("href", "http://" + $(this).attr("href"));
        }
    });

    // Messenoverview toggle
    $('.tgl_prev_messen').on('click', function () {
        $(this).find('span').toggleClass('icon-bottom_arrow icon-top_arrow');
        $(this).next('.prev_messen').toggle();
    });

    // Kalender - Filter submit on change
    $('#calenderfilterform select').on('change', function () {
        var tval = $(this).val();
        $(this).closest('form').find('select').attr('disabled', 'disabled');
        $(this).parent().find('input[type=\'hidden\']').val(tval);
        $(this).closest('form').submit();
    });

    //tabelle einfärben 🌈🤬
    $('table').each(function () {
        if ($(this).hasClass("table") || $(this).hasClass("recipe_order") || $(this).parents('div#recipe-wrapper').length) {
        }
        else {
            $(this).find('tr:odd').addClass('odd');
            $(this).find('tr:even').addClass('even');
        }
    });

}